module.exports = __webpack_public_path__ + "static/media/develop-01.85ba64da.png";